// components/Pagination.tsx

import React from 'react';
import styles from './Pagination.module.scss';
import { FaArrowLeft } from 'react-icons/fa';
import { FaArrowRight } from 'react-icons/fa';

interface PaginationProps {
	currentPage: number;
	totalPages: number;
	onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
	const handleClick = (page: number) => {
		if (page < 1 || page > totalPages) return;
		onPageChange(page);
	};

	const renderPageNumbers = () => {
		const pages = [];
		const maxVisiblePages = 3;
		const shouldShowDots = totalPages > maxVisiblePages + 2;

		// Previous Arrow
		pages.push(
			<button
				key='prev'
				className={styles.arrow}
				onClick={() => handleClick(currentPage - 1)}
				disabled={currentPage === 1}>
				<FaArrowLeft />
			</button>
		);

		for (let i = 1; i <= totalPages; i++) {
			if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
				pages.push(
					<button
						key={i}
						className={`${styles.pageNumber} ${currentPage === i ? styles.active : ''}`}
						onClick={() => handleClick(i)}>
						{i}
					</button>
				);
			} else if (shouldShowDots && (i === 2 || i === totalPages - 1)) {
				pages.push(
					<span key={`dots-${i}`} className={styles.dots}>
						...
					</span>
				);
			}
		}

		// Next Arrow
		pages.push(
			<button
				key='next'
				className={styles.arrow}
				onClick={() => handleClick(currentPage + 1)}
				disabled={currentPage === totalPages}>
				<FaArrowRight />
			</button>
		);

		return pages;
	};

	return <div className={styles.pagination}>{renderPageNumbers()}</div>;
};

export default Pagination;
